import { initials } from '../util/format.js';
import { Icon } from './Icon.js';
import styles from './Avatar.module.css';

interface AvatarProps {
  name: string;
  src?: string;
  online?: boolean;
  locked?: boolean;
  /** Blur without the lock icon: whether the profile is locked is not known yet. */
  blurred?: boolean;
  size?: number;
}

export function Avatar({ name, src, online, locked, blurred, size = 40 }: AvatarProps) {
  const blur = locked || blurred ? styles.blurred : '';
  return (
    /* Replaced wholesale in a session replay (AI-3016): a face IS an identity,
       and so are the initials standing in for one. Marked here rather than at
       each of the dozen call sites, so a new surface inherits it by reusing
       this component instead of by someone remembering to. */
    <span data-ph-block className={styles.avatar} style={{ width: size, height: size }}>
      {src ? (
        <img className={`${styles.image} ${blur}`} src={src} alt={name} />
      ) : (
        <span className={`${styles.initials} ${blur}`} style={{ fontSize: size * 0.36 }}>
          {initials(name)}
        </span>
      )}
      {locked && (
        <span className={styles.locked} role="img" aria-label="Locked profile">
          <Icon name="lock" size={Math.round(size * 0.4)} />
        </span>
      )}
      {online !== undefined && (
        <span
          className={online ? styles.dotOnline : styles.dotOffline}
          role="img"
          aria-label={online ? 'Online' : 'Offline'}
        />
      )}
    </span>
  );
}
